import { p as proxyCustomElement, H, c as createEvent, h, a as Host } from './index.js';
import { d as defineCustomElement$m } from './p-Cd2X-6KG.js';
import { d as defineCustomElement$l } from './p-BedvZv52.js';
import { d as defineCustomElement$k } from './p-BN9xIVU9.js';
import { d as defineCustomElement$j } from './p-CVlACDxe.js';
import { d as defineCustomElement$i } from './p-CkgLRZPl.js';
import { d as defineCustomElement$h } from './p-D-k_i6-R.js';
import { d as defineCustomElement$g } from './p-DZKBv4tL.js';
import { d as defineCustomElement$f } from './p-aAvJ0uEW.js';
import { d as defineCustomElement$e } from './p-kuoYNbOB.js';
import { d as defineCustomElement$d } from './p-BVCTlSQE.js';
import { d as defineCustomElement$c } from './p-D4xpFZtu.js';
import { d as defineCustomElement$b } from './p-BkDQJ61k.js';
import { d as defineCustomElement$a } from './p-Cy8qWWQl.js';
import { d as defineCustomElement$9 } from './p-DLWyhg_S.js';
import { d as defineCustomElement$8 } from './p-B6RR6Z8w.js';
import { d as defineCustomElement$7 } from './p-DaiIyqo3.js';
import { d as defineCustomElement$6 } from './p-DE-WBrSS.js';
import { d as defineCustomElement$5 } from './p-Dg3i2AwD.js';
import { d as defineCustomElement$4 } from './p-aqq22Qbe.js';
import { d as defineCustomElement$3 } from './p-Bjt5CD4D.js';
import { d as defineCustomElement$2 } from './p-QtR5VUMp.js';

const tableHeaderCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;flex-direction:row;font-family:Open Sans;font-size:.875rem;font-weight:400;justify-content:space-between;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.filters{display:flex;flex:1;flex-direction:row;gap:.5rem}.filters>*{max-width:var(--jw-container-xs)}::slotted(wui-multi-select-input){width:auto}.actions{display:flex;flex:none;flex-direction:row;gap:.5rem}";

const DENSITY_LABELS = {
    sm: 'small',
    md: 'medium',
    lg: 'large',
};
const DENSITY_ICONS = {
    sm: 'baseline-density-small',
    md: 'baseline-density-medium',
    lg: 'baseline-density-large',
};
const WuiTableHeader$1 = /*@__PURE__*/ proxyCustomElement(class WuiTableHeader extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        this.changeSearchQuery = createEvent(this, "changeSearchQuery", 7);
        this.changeVisibleColumns = createEvent(this, "changeVisibleColumns", 7);
        this.changeDensity = createEvent(this, "changeDensity", 7);
    }
    render() {
        const showDensityButtons = Boolean(this.density && this.densities?.length);
        const showColumnsInput = Boolean(this.columns?.length && typeof this.visibleColumns !== 'undefined');
        return (h(Host, { key: 'a59cb504790e38a168a0264044fcad18a5a0e4ea' }, h("div", { key: 'fe39292eaf70f6316139a2ccf3d50d0e68097d0c', class: "filters" }, h("wui-input", { key: 'a8166c8446fda8141248a6d17ed2df7e122263ed', type: "search", placeholder: this.searchInput?.placeholder ?? 'Search', value: this.searchQuery, onInput: (e) => {
                this.changeSearchQuery.emit(e.currentTarget?.value ?? '');
            } }), h("slot", { key: '9561ae9f7d9106a717ed510a4153f81b59007182' })), h("div", { key: 'f9a4ec8578753c878b0c7af42598bea02d20ba57', class: "actions" }, showDensityButtons && (h("wui-layout", { key: '24e0e18a68b4a7d086eea6a41245e8a79be6fb75', type: "button-group", variant: "button-group-tight" }, this.densities?.map((density) => {
            return (h("wui-button", { key: density, tooltip: `Density: ${DENSITY_LABELS[density]}`, icon: DENSITY_ICONS[density], type: "ghost", toggled: this.density === density, onClick: () => {
                    this.changeDensity.emit(density);
                } }));
        }))), showDensityButtons && showColumnsInput && h("wui-divider", { key: '1aff96a346805ac70c63a0e168c8c7d8f1db9cbf', type: "vertical" }), showColumnsInput && (h("wui-more-menu", { key: '4a746cea3e206c3ae2484085fdcbef0f0ed2ceaf', icon: "settings", menuPane: { placement: 'bottom-end' } }, h("wui-check-list-input", { key: 'bd59c89a00b6a41e3464f51adf36af0fe37bee87', options: this.columns?.map((col) => {
                const value = 'name' in col ? col.name : col.value;
                const label = col.label;
                return {
                    value,
                    label,
                };
            }), value: this.visibleColumns, onInput: (e) => {
                this.changeVisibleColumns.emit(e.currentTarget?.value ?? []);
            } }))))));
    }
    static get style() { return tableHeaderCss; }
}, [257, "wui-table-header", {
        "searchInput": [16, "search-input"],
        "searchQuery": [1, "search-query"],
        "columns": [16],
        "visibleColumns": [16, "visible-columns"],
        "densities": [16],
        "density": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-table-header", "wui-box", "wui-button", "wui-check-input", "wui-check-list-input", "wui-close-button", "wui-divider", "wui-form-field", "wui-icon", "wui-input", "wui-layout", "wui-list", "wui-list-item", "wui-list-item-divider", "wui-list-item-header", "wui-list-item-meta", "wui-loader", "wui-menu-pane", "wui-more-menu", "wui-status", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-table-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTableHeader$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$m();
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$l();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$k();
            }
            break;
        case "wui-check-list-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$j();
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$i();
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$h();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$g();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$f();
            }
            break;
        case "wui-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "wui-layout":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "wui-list":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "wui-list-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-list-item-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-list-item-header":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-list-item-meta":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-menu-pane":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-more-menu":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiTableHeader = WuiTableHeader$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTableHeader, defineCustomElement };
